document.addEventListener("DOMContentLoaded", function() {

    const contentElementWithEffects = document.querySelectorAll('#image-video, #seminars-upcoming, #seminars-target-groups ul');
    const options = {
        rootMargin: '0px 0px -250px 0px',
        threshold: .5
    };
    const delay = 250;
    const effectsAppliedClass = 'effects-applied';
    let delayIteration = 0;

    if (contentElementWithEffects.length) {
        try {
            const intersectionObserver = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.intersectionRatio > 0) {
                        const element = entry.target;
                        if (!element.classList.contains(effectsAppliedClass)) {
                            element.classList.add(effectsAppliedClass);
                            switch (element.id) {
                                case 'image-video':
                                    element.querySelector('video').play();
                                    break;
                                default:
                                    break;
                            }
                        }
                    }
                });
            }, options);
            contentElementWithEffects.forEach(element => {
                intersectionObserver.observe(element);
            });
        }
        catch (error) {
            console.error(error);
        }
    }

});
